import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Venue } from '../models/venue';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class VenueService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Venue> {
  	return this.getWithRest('id/' + id);
  }

  private getWithRest(rest_url: string) : Promise<Venue> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'venues/' + rest_url).subscribe((response:any) => {

      if(response.type == 'venue' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

}
